var React = require('react');

function Brand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.82 19.16L20.82 1.16C20.1 0.44 19.1 0 18 0H4C1.8 0 0 1.8 0 4V18C0 19.1 0.44 20.1 1.18 20.84L19.18 38.84C19.9 39.56 20.9 40 22 40C23.1 40 24.1 39.56 24.82 38.82L38.82 24.82C39.56 24.1 40 23.1 40 22C40 20.9 39.54 19.88 38.82 19.16ZM7 10C5.34 10 4 8.66 4 7C4 5.34 5.34 4 7 4C8.66 4 10 5.34 10 7C10 8.66 8.66 10 7 10ZM30.54 26.54L22 35.08L13.46 26.54C12.56 25.62 12 24.38 12 23C12 20.24 14.24 18 17 18C18.38 18 19.64 18.56 20.54 19.48L22 20.92L23.46 19.46C24.36 18.56 25.62 18 27 18C29.76 18 32 20.24 32 23C32 24.38 31.44 25.64 30.54 26.54Z","fill":"currentColor"}));
}

Brand.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Brand;

Brand.default = Brand;
